import Vue from 'vue';

Vue.component('pdb-landing-page-index', () =>
    import(/* webpackChunkName: 'pdb-landing-page-index' */ './pdb-landing-page-index.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/pdb-landing-page/index.js